export default __webpack_public_path__ + "resources/icons/n420-a20b.png";